import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledContainer = styled.div`
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
`;

const StyledImg = styled.img`
    max-width: 100%;
    max-height: 300px;
`;

const ProductLogo = (props) => {
    const {
        alt,
        src,
    } = props;

    if (!src) {
        return null;
    }

    return (
        <StyledContainer>
            <StyledImg src={ src } alt={ alt } />
        </StyledContainer>
    );
};

ProductLogo.propTypes = {
    src: PropTypes.string,
    alt: PropTypes.string,
};

export default ProductLogo;



// WEBPACK FOOTER //
// ./src/pages/products/show/ProductLogo.js